<template>
  <SfModal
    size="xxl"
    :content-padding="0"
    :scrollable-content="false"
    class-name="company-inbox-modal"
    content-class-name="tw-flex-1 tw-min-h-0 tw-flex tw-flex-col"
    @close="close"
  >
    <template #title>
      {{ modalTitle }}
      <a
        :href="firmInboxPath"
        class="
          sf-btn
          tw-no-underline
          tw-shrink-0
          tw-absolute
          tw-right-14
          tw-top-1/2
          tw--translate-y-1/2
        "
        data-testid="go-to-firm-inbox"
      >
        {{ I18n.t('inbox.modal.go_to_firm_inbox') }}
      </a>
    </template>

    <template #body>
      <div class="tw-flex tw-flex-col tw-flex-1 tw-min-h-0">
        <div
          class="
            tw-px-6
            tw-py-3
            tw-shrink-0
            tw-border-t
            tw-border-b
            tw-border-l-0
            tw-border-r-0
            tw-border-solid
            tw-border-sf-neutral-lighter-2
          "
        >
          <InboxFilters :show-authors-filter="true" />
        </div>
        <div
          class="
            tw-flex-1
            tw-min-h-0
            tw-bg-sf-neutral-subtle-1
            tw-px-12
            tw-py-6
            tw-flex
            tw-justify-center
            tw-rounded-b-lg
          "
        >
          <div
            class="
              tw-w-full
              tw-max-w-condensed-content
              tw-h-full
              tw-overflow-hidden
              tw-rounded-2xl
              tw-border
              tw-border-solid
              tw-border-sf-neutral-lighter-2
              tw-bg-white
            "
          >
            <CompanyInbox in-modal />
          </div>
        </div>
      </div>
    </template>
  </SfModal>
</template>

<script setup>
import { SfModal } from '@app/shared/vue/components/sf-modal'
import CompanyInbox from './company-inbox.vue'
import InboxFilters from './inbox-filters.vue'
import useI18n from '@app/shared/vue/composables/use-I18n'

const props = defineProps({
  periodName: {
    type: String,
    default: '',
  },
  firmInboxPath: {
    type: String,
    required: true,
  },
})

const emit = defineEmits(['close'])
const I18n = useI18n()

const modalTitle = I18n.t('inbox.modal.title', { period: props.periodName })

function close() {
  emit('close')
}
</script>

<style lang="scss">
.company-inbox-modal .sf-modal-header .sf-modal-title {
  flex: 1;
  text-align: center;
}
</style>
